import { Button, Result } from 'antd'
import { useEffect } from 'react';
import { setHeaderName } from '../../services/SetHeaderName';

export const NotFoundPage = () => {

    useEffect(() => {
        setHeaderName('Not Found')
    }, []);
    return (
        <div className='mt-5'>
            <Result
                className='text-center'
                status="404"
                title="404"
                subTitle="Sorry, the page you visited does not exist."
            // extra={<Button type="primary">Back Home</Button>}
            />
        </div>
    )
}